module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title",
    attrs: {
      "id": "time"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TIMELINE")])]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1910")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("Korea is annexed to the Japanese Empire.")]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1945")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("15 August: Japan surrenders. US President Harry S. Truman issues a General Order partitioning Korea at the 38th Parallel to facilitate Soviet and American occupying forces to disarm and demobilize the Japanese.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("24 August: Soviet troops complete the occupation of their northern half of Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("8 September: US occupation forces arrive in Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1947")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("14 November: The United Nations establishes the UN Temporary Commission on Korea (UNTCOK) for the sole purpose of supervising a general election throughout Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1948")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("12 January: UNTCOK establishes its headquarters in the Seoul.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("23 January: Soviet occupation forces block United Nations Commission on Korea (UNCOK) from entering North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("10 May: UNTCOK supervises a general election held in South Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("15 August: An elected government of the Republic of Korea is formed.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("12 December: The UN General Assembly recognizes the government of the Republic of Korea as the only lawful government in Korea. The permanent UN Commission on Korea is activated.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("26 December: Soviet troops complete their withdrawal from North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1949")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("The US, Britain, Canada, New Zealand and Australia recognize the Republic of Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("29 June: American occupation forces complete their evacuation of South Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1950")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("25 June: Massed Soviet-trained and -equipped North Korean forces invade the south.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("26 June: The UN Security Council condemns the North Korean attack as a threat to regional peace and international security, calling on P’yŏngyang to withdraw back north of the 38th Parallel.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("27 June: The UN Security Council calls upon all its member states to support South Korea. US President Harry S. Truman orders air and naval forces to support the south.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("28 June: The South Korean government vacates the capital, Seoul.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("29 June: Elements of the Royal Navy and the Royal Australian Navy arrive in Korean waters.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("1 July: The UN creates a unified command and General Douglas MacArthur is appointed Commander-in-Chief.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("14 July: South Korean forces are placed under the UN command.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("20 July: Taejon falls to the North Koreans.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("21 July: Canadian transport aircraft arrive in Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("30 July: Royal Canadian Navy forces arrive in Korean waters. The Naktong River defence line is established.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("1 August: Royal New Zealand ships arrive in Korean waters.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("28 August: The British 27th Infantry Brigade under Brigadier Basil A. Coad arrives at Pusan.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("15 September: US-led UN forces launch an amphibious landing at Inch’ŏn.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("16 September: UN forces commence a breakout from the defensive Pusan Perimeter.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("28 September: UN forces liberate Seoul. The Royal Australian Regiment arrives in Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("1 October: South Korean forces cross the 38th Parallel into North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("2 October: China threatens to intervene if UN forces enter North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("7 October: The UN authorizes UN forces to pursue the retreating North Korean army into North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("16 October: The Chinese People’s Volunteer Army moved invades North Korea from Manchuria.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("19 October: P’yŏngyang, capital of North Korea, is taken by UN forces.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("26 October: UN forces reach the Yalu River border with China, where Chinese forces are engaged. US forces land at Wŏnsan on the Korean east coast.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("27 October: The Chinese launch their first offensive against UN forces.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("1 November: Chinese MiG fighter aircraft cross the Yalu River for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("3–18 November: The British 29th (Independent) Brigade under Brigadier Thomas Brodie arrives at Pusan.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("7 November: The Canadian 25th Infantry Brigade starts arriving at Pusan.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("20 November: The 60th Indian Field Ambulance arrives in Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("24 November: General MacArthur orders his troops to march on the Yalu River.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("25 November: The Chinese launch their second offensive.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("27 November: Chinese troops penetrate the US Eighth Army line, cutting off the US 1st Marine Division at the Changjin (Chosin) Reservoir.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("15 December: UN forces withdraw from Hŭngnam and Wŏnsan to consolidate on the 38th Parallel.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("23 December")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("US Eighth Army commander, Lieutenant General Walton Walker is killed in a vehicle collision. He is succeeded by Lieutenant General Matthew B. Ridgway.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("31 December: New Zealand field artillery arrives in South Korea.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "timet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1951")])]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("4 January: UN forces evacuate Seoul.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("25 January: UN forces launch Operation Thunderbolt, advancing on the Han River at Seoul.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("1 February: The UN condemns China’s invasion of North Korea.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("21 February: The US Eighth Army launches Operation Killer in a fresh offensive to the north.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("7 March: The US Eighth Army launches Operation Ripper to advance across the Han River.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("15 March: UN forces retake Seoul.")]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v("31 March: UN forces arrive at the 38th Parallel.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a913c64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Timeline.vue
// module id = 69
// module chunks = 0